export function MSolStaking() {
    return (
        <div>
        </div>
    );
}
